import TextWithIcon from 'components/elements/TextWithIcon'

interface ParticipantInfoFieldsOptions {
  eventName: string
  categoryName?: string
  firstName: string
  lastName: string
}

/**
 * Shared form fields for displaying participant read-only info.
 * Used by JerseyFormContent, UploadResultFormContent, and ParticipantMoreInfoFormContent.
 */
export const participantInfoDisplayFields = ({
  eventName,
  categoryName,
  firstName,
  lastName,
}: ParticipantInfoFieldsOptions) => [
  { id: 'eventName', size: 6, field: <TextWithIcon title="Event" text={eventName} /> },
  { id: 'categoryName', size: 6, field: <TextWithIcon title="Category" text={categoryName || ''} /> },
  { id: 'firstName', size: 6, field: <TextWithIcon title="First Name" text={firstName} /> },
  { id: 'lastName', size: 6, field: <TextWithIcon title="Last Name" text={lastName} /> },
]
